var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyriusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 44.4715L64 2.16016V63.9998L29.5 44.4715Z",
    fill: "url(#paint0_linear_341_1102)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 21.6885L64 2.16016L29.5 44.4715V21.6885Z",
    fill: "url(#paint1_linear_341_1102)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 21.6885L64 2.16016V41.2168L98.5 21.6885Z",
    fill: "url(#paint2_linear_341_1102)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 83.5285L64 125.84L64 64.0002L98.5 83.5285Z",
    fill: "url(#paint3_linear_341_1102)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 106.312L64 125.84L98.5 83.5285L98.5 106.312Z",
    fill: "url(#paint4_linear_341_1102)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 106.312L64 125.84L64 86.7832L29.5 106.312Z",
    fill: "url(#paint5_linear_341_1102)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_1102",
    x1: 64,
    y1: 2.16016,
    x2: 29.5,
    y2: 2.16016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_341_1102",
    x1: 41.5425,
    y1: 30.1507,
    x2: 29.5,
    y2: 21.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_341_1102",
    x1: 98.5,
    y1: 21.6885,
    x2: 64,
    y2: 21.6885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FF02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_341_1102",
    x1: 64,
    y1: 125.84,
    x2: 98.5,
    y2: 125.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1255AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_341_1102",
    x1: 86.4575,
    y1: 97.8493,
    x2: 98.5,
    y2: 106.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1762C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244269"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_341_1102",
    x1: 29.5,
    y1: 106.312,
    x2: 64,
    y2: 106.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyriusLogo);
export default __webpack_public_path__ + "static/media/syrius-logo.1ef2da2864a2937aebf2462f44194e36.svg";
export { ForwardRef as ReactComponent };